import React, { createRef, RefObject } from 'react';

import videoStyle from './recipe-video.module.css';

type RecipeVideoProps = {
  url: string;
  poster: string
};


class RecipeVideo extends React.Component<RecipeVideoProps, {}> {
  $vp: RefObject<HTMLDivElement>;
  ratio = 406/720;

  constructor(props: RecipeVideoProps) {
    super(props);

    this.$vp = createRef();
  }

  updateVPSize = () => {
    if ( !this.$vp.current ) {
      return;
    }

    // 138 = header Height
    const maxHeight = ( window.innerHeight - 150 ) / 100 * 85;
    const maxWidth  = Math.min(window.innerWidth / 100 * 80, 500);

    let width = maxWidth, height = maxWidth / this.ratio;

    if ( height > maxHeight ) {
      height = maxHeight;
      width  = maxHeight * this.ratio;
    }

    this.$vp.current.style.width  = `${ width }px`
    this.$vp.current.style.height = `${ height }px`
  }

  componentDidMount() {
    this.updateVPSize();
    window.addEventListener( 'resize', this.updateVPSize );
  }


  componentWillUnmount() {
    window.removeEventListener( 'resize', this.updateVPSize );
  }

  render() {
    const { url, poster } = this.props;

    return (
      <div
        className={`recipe-content ${videoStyle.container}`}
      >
        <div className={ videoStyle.viewport } ref={ this.$vp }>
          <video id="recipe-video" className={videoStyle.video} controls 
            width="406"
            height="720"
            src={url} 
            poster={poster}
            ></video>
        </div>
      </div>
    );
  }
}

export default RecipeVideo;
